export default __webpack_public_path__ + "static/media/Vazir-Bold.1ec582b9.ttf";